// @ts-nocheck

const getCompClass =
  (compType) =>
  (dispatch, getState, { compFactoryService }) =>
    compFactoryService.getCompClass(compType);

export { getCompClass };
